<div class="flex flex-column h-full">
  <div class="flex gap-2">
    <div class="flex-grow-1">
      <div class="flex gap-2 mb-2">
        <div class="flex p-inputgroup bg-transparent" style="max-width: 300px">
          <input
            type="text"
            pInputText
            [(ngModel)]="searchText"
            placeholder="{{ 'ENV.SEARCH' | translate }}"
            class="bg-transparent text-right"
            autocomplete="false"
          />
          <span class="p-inputgroup-addon bg-transparent"
            ><i class="pi pi-search" style="line-height: 1.25"></i
          ></span>
        </div>
        <button
          pButton
          pTooltip="Resetear filtros"
          tooltipPosition="bottom"
          icon="pi pi-filter-slash"
          class="p-button-warning ml-2 mr-4"
          (click)="resetDTFilters()"
        ></button>
      </div>
    </div>

    <div class="flex justify-content-end mb-2 mx-3">
      <button
        pButton
        pRipple
        type="button"
        icon="pi pi-plus"
        label="{{ 'FORM.ADD-SELECTED' | translate }}"
        class="p-button-success me-3 position-relative"
        (click)="onItemSelectedInBatch()"
        [disabled]="!(selectedRows.length > 0)"
        *ngIf="multiple"
      ></button>
    </div>
  </div>
  <div class="flex-grow overflow-hidden h-full">
    <p-table
      [columns]="columns"
      [dataKey]="keys.primary_key"
      [value]="rows"
      [loading]="loading"
      [paginator]="true"
      [rows]="rowsPerPage"
      [showCurrentPageReport]="true"
      [rowsPerPageOptions]="rowsPerPageOptions"
      styleClass="p-datatable-gridlines"
      [(selection)]="selectedRows"
      [scrollable]="true"
      scrollHeight="flex"
      [resizableColumns]="true"
      [currentPageReportTemplate]="
        'GENERAL.SHOWING-X-TO-Y-OF-Z-ROWS'
          | translate
            : {
                first: '{first}',
                last: '{last}',
                totalRecords: '{totalRecords}'
              }
      "
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th style="width: 3rem" pFrozenColumn *ngIf="multiple">
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <ng-container *ngFor="let col of columns">
            <th
              [pSortableColumn]="col.sortable"
              pFrozenColumn
              [frozen]="col.frozen"
              pResizableColumn
              [pResizableColumnDisabled]="!col.resizable"
              [width]="col.width"
              [style.minWidth.px]="col.resizable ? 0 : col.width"
              *ngIf="col.visible"
            >
              <div class="flex align-items-center gap-2">
                {{ col.header | translate }}
                <p-sortIcon
                  *ngIf="col.sortable"
                  [field]="col.sortable"
                ></p-sortIcon>

                <div [ngSwitch]="col.field" *ngIf="col.filterable">
                  <div *ngSwitchCase="'tags'">
                    <app-filter-comma-separated
                      [field]="'tags'"
                      [matchModeOptions]="matchModeOptions"
                      [data]="rows"
                    >
                    </app-filter-comma-separated>
                  </div>
                  <div *ngSwitchCase="'type_'">
                    <app-filter-content-type
                      [field]="'type_'"
                      [matchModeOptions]="matchModeOptions"
                      [data]="rows"
                    >
                    </app-filter-content-type>
                  </div>
                  <div *ngSwitchDefault>
                    <p-columnFilter
                      type="text"
                      [field]="col.sortable"
                      display="menu"
                      class="ml-auto"
                    ></p-columnFilter>
                  </div>
                </div>
              </div>
            </th>
          </ng-container>
          <th
            style="min-width: 125px"
            [width]="125"
            alignFrozen="right"
            pFrozenColumn
          ></th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-row let-columns="columns">
        <tr>
          <td pFrozenColumn *ngIf="multiple">
            <p-tableCheckbox [value]="row"></p-tableCheckbox>
          </td>
          <ng-container *ngFor="let col of columns">
            <td
              pFrozenColumn
              [frozen]="col.frozen"
              [width]="col.width"
              *ngIf="col.visible"
            >
              <ng-container [ngSwitch]="col.field">
                <div
                  *ngSwitchCase="'type_'"
                  class="text-center"
                  style="white-space: pre-line"
                >
                  <span
                    class="material-symbols-outlined"
                    style="font-size: 2rem"
                    [pTooltip]="
                      globals.CONTENT_TYPES[row.type_].label | translate
                    "
                  >
                    {{ globals.CONTENT_TYPES[row.type_].materialIcon }}
                  </span>
                </div>
                <div *ngSwitchDefault style="white-space: pre-line">
                  {{ col.field | ngCellValue : row }}
                </div>
              </ng-container>
            </td>
          </ng-container>
          <td
            style="min-width: 125px"
            [width]="125"
            class="p-2"
            alignFrozen="right"
            pFrozenColumn
          >
            <div
              class="flex flex-grow-1 justify-content-center md:justify-content-end mt-2 md:mt-0 gap-2"
            >
              <app-content-trigger-button
                [item]="row"
              ></app-content-trigger-button>
              <button
                *ngIf="showSelectOneButton"
                pButton
                pRipple
                icon="pi pi-plus"
                pTooltip="{{ 'FORM.ADD' | translate }}"
                class="p-button-text p-button-raised p-button-success"
                (click)="onItemSelected(row)"
              ></button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="8">{{ "WIDGET.DT-EMPTY" | translate }}</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>

<p-sidebar
  [(visible)]="isColumnToggleVisible"
  position="right"
  [baseZIndex]="10000"
  [style]="{ width: '100%', 'max-width': '20em' }"
>
  <app-prime-list-columns-toggle
    [(columns)]="columns"
  ></app-prime-list-columns-toggle>
</p-sidebar>
